var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"main",on:{"click":_vm.handelDownload}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isModel),expression:"isModel"}],staticClass:"model",on:{"click":function($event){_vm.isModel = false}}})])}
var staticRenderFns = []

export { render, staticRenderFns }